import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { CMSEvent, CMSEventType } from 'render/models/cms-event.model';


@Injectable({
  providedIn: 'root'
})
export class CMSRenderEventsService {

  public cmsEvent = new Subject<CMSEvent<CMSEventType>>();
  private readonly events: Record<string, Subject<CMSEvent<CMSEventType>>> = {};

  public emitEvent(event: CMSEvent<CMSEventType>): void {
    if (!this.events[event.name]) {
      this.events[event.name] = new Subject<CMSEvent<CMSEventType>>();
    }
    this.cmsEvent.next(event);
    this.events[event.name].next(event);
  }

  public getEvent(name: string): Subject<CMSEvent<CMSEventType>> {
    if (!this.events[name]) {
      this.events[name] = new Subject<CMSEvent<CMSEventType>>();
    }
    return this.events[name];
  }

}
